import React from 'react'

const ODockType = ({ show, shipment }) => {

    if (show && shipment) {
        if (shipment.shipper?.dockType === 'dock') {
            return (
                <div>Business with Dock/Forklift</div>
            )
        }
        if (shipment.shipper?.dockType === 'nodock') {
            return (
                <div>Business without Dock/Forklift</div>
            )
        }
        return null
    }
    return null
}

export default ODockType